import { formatMoney } from "../../api";

export const splitList = (text) => (text || "").split(",").map((s) => s.trim()).filter(Boolean);

export function budgetText(job, currency = "USD") {
  const { budget_min: min, budget_max: max } = job;
  const suffix = job.budget_type === "hourly" ? "/hr" : "";
  const hasMin = min !== null && min !== undefined && Number(min) > 0;
  const hasMax = max !== null && max !== undefined && Number(max) > 0;
  if (!hasMin && !hasMax) return "Budget negotiable";
  if (hasMin && hasMax && Number(min) !== Number(max)) return `${currency} ${formatMoney(min)} - ${formatMoney(max)}${suffix}`;
  return `${currency} ${formatMoney(hasMax ? max : min)}${suffix}`;
}

export function timeAgo(iso) {
  const seconds = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  const units = [["year", 31536000], ["month", 2592000], ["day", 86400], ["hour", 3600], ["minute", 60]];
  for (const [name, size] of units) {
    if (seconds >= size) {
      const n = Math.floor(seconds / size);
      return `${n} ${name}${n > 1 ? "s" : ""} ago`;
    }
  }
  return "just now";
}

export const STATUS_STYLES = {
  open: "bg-emerald-500/15 text-emerald-400",
  in_progress: "bg-sky-500/15 text-sky-400",
  completed: "bg-violet-500/15 text-violet-400",
  closed: "bg-white/10 text-gray-400",
  pending: "bg-amber-500/15 text-amber-400",
  accepted: "bg-emerald-500/15 text-emerald-400",
  rejected: "bg-red-500/15 text-red-400",
  withdrawn: "bg-white/10 text-gray-400",
};

export const STATUS_LABELS = {
  open: "Open", in_progress: "In progress", completed: "Completed", closed: "Closed",
  pending: "Pending", accepted: "Accepted", rejected: "Rejected", withdrawn: "Withdrawn",
};

export const cardClass =
  "rounded-xl bg-navy-dark border border-accent-light/25 shadow-[0_0_15px_rgba(34,211,238,0.15)]";
